import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/course_issuance',
    name: 'courseIssuance',
    meta: {
        title: '课程/发卡',
        isAdmin: true
    },
    component: Layout,
    redirect: '/course_issuance/course_card_list',
    children: [
        {
            path: 'course_card_list',
            name: 'courseCardList',
            meta: {
                title: '课程/发卡列表',
                isAdmin: true
            },
            component: resolve => require(['@/views/courseIssuance/courseCardList/Index.vue'], resolve),
        },
        {
            path: 'course_card_list',
            meta: {
                title: '课程/发卡列表',
                isAdmin: true
            },
            component: Empty,
            children: [
                {
                    path: 'assign_course',
                    name: 'assignCourse',
                    alias: '/assignCourse',
                    meta: {
                        title: '分配课程',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/courseIssuance/assignCourse/Index.vue'], resolve),
                },
                {
                    path: 'record_list',
                    name: 'recordList',
                    alias: '/recordList_2',
                    meta: {
                        title: '发卡记录',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/courseIssuance/recordList/Index.vue'], resolve),
                },
                {
                    path: 'record_list',
                    meta: {
                        title: '发卡记录',
                        isAdmin: true
                    },
                    component: Empty,
                    children: [
                        {
                            path: 'student_card',
                            name: 'student_card',
                            alias: '/student_card',
                            meta: {
                                title: '发卡详情',
                                isAdmin: true
                            },
                            component: resolve => require(['@/views/courseIssuance/studyCard/Index.vue'], resolve),
                        },
                    ]
                },
                {
                    path: 'money_back_or_refund',
                    name: 'moneyBackOrRefund',
                    alias: '/money_back_or_refund_3',
                    meta: {
                        title: '回款_退款',
                        isAdmin: true
                    },
                    component: resolve => require(['@/views/courseIssuance/moneyBackOrRefund/Index.vue'], resolve),
                },
            ]
        },
        {
            path: 'organ_card_list',
            name: 'organCardList',
            meta: {
                title: '机构发卡记录',
                isAdmin: true
            },
            component: resolve => require(['@/views/courseIssuance/organCardList/Index.vue'], resolve),
        },
        {
          path: 'clear_car_list',
          name: 'clearCarList',
          meta: {
              title: '清除学习卡权限',
              isAdmin: true
          },
          component: resolve => require(['@/views/courseIssuance/clearCardList/Index.vue'], resolve),
      },
    ]
}
